
import { EventBus } from '@/app/shared/services/event-bus.js';
import localeEn from '@/app/pharmacy/locales/en'
import localeAr from '@/app/pharmacy/locales/ar'
import { showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';
import { visitService } from '@/app/pharmacy/shared/services/visit-service';
import { getSaveResultEnum, getCreateVisitResultEnum } from '@/app/pharmacy/shared/pharmacy-enums.js';



export default {

    data() {
        return {
            dimmedReprice:false,
            hideNotification: 5000,
            suffix: 'reprice-popup',
            flage: true,
            visitinfo: {},
            confirmdata: [
                {
                    confirmText: '',
                    confirmBtnBtnText: '',
                    cancelBtnText: '',
                    headerTitle: '',
                    messageText: '',
                    poptype: '',
                    itemName: '',
                    qmark: '',
                    popupclass: ''
                }
            ],
        }
    },
    props: [
        'msuffix'
    ],
    methods: {
        showPopupNotification,
        cancel() {
            this.$refs['pay-modal-ref'].hide();
            EventBus.$emit('CancelClicked', "");
        },


        reprice() {
            this.dimmedReprice = true
            EventBus.$emit('ShowLoader');

            this.visitinfo = {
                ID: this.$store.getters.gridPatientDisHistory.visitId,
                SelectedVisitClassification: this.$store.getters.gridPatientDisHistory.selectedVisitClassification,
                reloadGridOnly: true

            };
            let VisitID = this.$store.getters.gridPatientDisHistory.visitId;
            visitService.RePrice(VisitID, (response) => {
                this.dimmedReprice = false
                if (response.data) {
                    switch (response.data) {
                        case parseInt(getSaveResultEnum().SavedSuccess):
                            this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('repricePopup.ServicesPricesUpdatedSuccessfully')}`, `success`);
                            this.$store.dispatch("load_gridOnClickingPatient", this.visitinfo);
                            break;

                        case parseInt(getSaveResultEnum().FailedToSave):
                            this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('clinicalServices.AddedPage.faliedToster')}`, `error`);
                            this.$store.dispatch("load_gridOnClickingPatient", this.visitinfo);
                            break;

                        case parseInt(getSaveResultEnum().FailureInBilling):
                            this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('insurancePopup.SystemErrorInBilling')}`, `error`);
                            this.cancel();
                            this.$store.dispatch("load_gridOnClickingPatient", this.visitinfo);
                            break;

                        case parseInt(getSaveResultEnum().NotValidStatus):
                            this.showPopupNotification(`${this.$i18n.t('Common.Warning')}`, `${this.$i18n.t('insurancePopup.ActionIsDeniedTheVisitStateIsChangedByAnotherUser')}`, `warning`);
                            this.cancel();
                            this.$store.dispatch("load_gridOnClickingPatient", this.visitinfo);
                            break;

                        case parseInt(getSaveResultEnum().HasClaimedService):
                            this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('insurancePopup.CannotEditVisitIncludeClaimedService')}`, `error`);
                            this.cancel();
                            this.$store.dispatch("load_gridOnClickingPatient", this.visitinfo);
                            break;
                        case parseInt(getCreateVisitResultEnum().ValidatedService):
                            this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('clinicalServices.ValidatedMsg')}`, `error`);
                            this.cancel();
                            this.$store.dispatch("load_gridOnClickingPatient", this.visitinfo);
                            break;
                        case parseInt(getCreateVisitResultEnum().ClaimedAndValidatedService):
                            this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('clinicalServices.ValidatedClaimedMsg')}`, `error`);
                            this.cancel();
                            this.$store.dispatch("load_gridOnClickingPatient", this.visitinfo);
                            break;

                        case parseInt(getSaveResultEnum().Concurrency):
                            this.showPopupNotification(`${this.$i18n.t('clinicalServices.AddedPage.concurrency')}`, `${this.$i18n.t('Common.Concurrency')}`, `warning`);
                            this.cancel();
                            this.$store.dispatch("load_gridOnClickingPatient", this.visitinfo);
                            break;
                    }

                    EventBus.$emit('HideLoader')

                }

                this.$refs['pay-modal-ref'].hide();

            }, () => {
                    this.cancel();
                    EventBus.$emit('HideLoader');
                    this.$refs['pay-modal-ref'].hide();

            });

        }


    },

    mounted() {
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();



    },
    components: {
        showPopupNotification
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
}
